import ScrollMagic from 'scrollmagic';
import { TweenMax, Expo } from "gsap/TweenMax";

const newController = new ScrollMagic.Controller();

const onCompleteAll = ( $el, offset = 150 ) => {
  setTimeout( () => {
    $el.find( '.blind-blocks' ).remove();
  }, offset );
};

/**
 * Blind effect function
 * @param {String} target - Input string
 * @param {String} className - class name
 * @param {Object} controller - controller
 * @param {Integer} offset - Trigger offset
 * @returns {Void} void
 */
export function blindsEffects( target, className = '', controller, offset = 50 ) {

  $( target ).each( function( index, el ) {
    new ScrollMagic.Scene({
      triggerElement: $( el )[0],
      offset:         offset,
      triggerHook:    0.9,
      reverse:        false
    }).addTo( controller ? controller : newController )
      .removeClassToggle()
      .on( 'start', function() {
        TweenMax.set( $( el )[0], {
          className: '-=' + className,
          delay:     0.95
        });
        TweenMax.staggerTo(
          $( el ).find( '.blind-block' ),
          1.5,
          {
            scaleY:          0,
            transformOrigin: "100% top",
            ease:            Expo.easeInOut,
          },
          0.15,
          onCompleteAll,
          [ $( el ) ]
        );
      });
  });
}
